module.exports = __webpack_public_path__ + "media/images/subject_img/RADIOGRAPHY-MEDICAL TECHNOLOGY-6a42df083945f0bcd3f25016397918d6.jpg";